import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=76fbf9ae&scoped=true"
import script from "@/views/Webshop/ProductDetail/ProductDetail.ts?vue&type=script&lang=ts&external"
export * from "@/views/Webshop/ProductDetail/ProductDetail.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Webshop/ProductDetail/product-detail.scss?vue&type=style&index=0&id=76fbf9ae&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fbf9ae",
  null
  
)

export default component.exports